import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { SquadCastComponentsModule } from '../../components/squadcast.components.module';
import { DescriptLinkPage } from './descript-link.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: DescriptLinkPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [DescriptLinkPage],
})
export class DescriptLinkModule {}
